'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildCommonMessage = undefined;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _immutable = require('immutable');

var _reduce = require('transmute/reduce');

var _reduce2 = _interopRequireDefault(_reduce);

var _CommonMessage = require('../records/CommonMessage');

var _CommonMessage2 = _interopRequireDefault(_CommonMessage);

var _timestamps = require('../../lib/timestamps');

var _messageTypes = require('../../pubnub-message/constants/messageTypes');

var _Status = require('../records/Status');

var _Status2 = _interopRequireDefault(_Status);

var _EmailMetadata = require('../records/EmailMetadata');

var _EmailMetadata2 = _interopRequireDefault(_EmailMetadata);

var _FileAttachment = require('../records/FileAttachment');

var _FileAttachment2 = _interopRequireDefault(_FileAttachment);

var _attachmentTypes = require('../constants/attachmentTypes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var buildCommonMessage = exports.buildCommonMessage = function buildCommonMessage() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var status = (0, _Status2.default)((0, _getIn2.default)(['status'], props));

  var attachments = (0, _reduce2.default)((0, _immutable.List)(), function (attachmentList, attachment) {
    var attachmentType = attachment[_messageTypes.MESSAGE_TYPE_ID];
    switch (attachmentType) {
      case _attachmentTypes.EMAIL_METADATA:
        return attachmentList.push((0, _EmailMetadata2.default)((0, _immutable.fromJS)(attachment)));
      case _attachmentTypes.FILES:
        return attachmentList.push((0, _FileAttachment2.default)((0, _immutable.fromJS)(attachment)));
      default:
        return attachmentList;
    }
  }, (0, _getIn2.default)(['attachments'], props));

  return (0, _CommonMessage2.default)((0, _immutable.fromJS)(props)).set('status', status).set('attachments', attachments).set('timestamp', (0, _getIn2.default)(['timestamp'], props) || (0, _timestamps.generateUniqueClientTimestamp)('buildCommonMessage-timestamp'));
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/common-message-format/operators/buildCommonMessage.js
// module id = 377
// module chunks = 2 3